import { h } from 'vue';
import {
  createRouter as _createRouter,
  createWebHistory,
  isNavigationFailure,
} from 'vue-router';

import AccessDenied from '@/components/AccessDenied.vue';
import CreditPackPurchaseModal from '@/components/billing/CreditPackPurchaseModal.vue';
import CreditUsageModal from '@/components/billing/CreditUsageModal.vue';
import ChooseDataSource from '@/components/dash/newOnboarding/ChooseDataSource.vue';
import InviteCrmAdminsModal from '@/components/dash/newOnboarding/InviteCrmAdminsModal.vue';
import InvitePartnerModal from '@/components/dash/newOnboarding/InvitePartnerModal.vue';
import DataSourceDeleteModal from '@/components/data-sources/DataSourceDeleteModal.vue';
import DataSourceRenameModal from '@/components/data-sources/DataSourceRenameModal.vue';
import DataTemplates from '@/components/data-sources/DataTemplates.vue';
import RemoveSourceModal from '@/components/data-sources/RemoveSourceModal.vue';
import { DataSourceSettingsTabType } from '@/components/data-sources/SettingsModal/constants';
import DataSourceSettingsModal from '@/components/data-sources/SettingsModal/DataSourceSettingsModal.vue';
import FieldPresetEditor from '@/components/field-presets/FieldPresetEditor.vue';
import DatabricksIntegrationSettingsDrawer from '@/components/integrations/DatabricksIntegrationSettingsDrawer.vue';
import OAuthSettingsDrawer from '@/components/integrations/OAuthSettingsDrawer.vue';
import SalesforceCustomObjectSettingsDrawer from '@/components/integrations/SalesforceCustomObjectSettingsDrawer.vue';
import SnowflakeIntegrationSettingsDrawer from '@/components/integrations/SnowflakeIntegrationSettingsDrawer.vue';
import BookMeetingModal from '@/components/onboarding/BookMeetingModal.vue';
import PartnershipSettingsModal from '@/components/partners/DataSharingSettings/SettingsModal/PartnershipSettingsModal.vue';
import DeletePartnershipModal from '@/components/partners/DeletePartnershipModal.vue';
import SharingDashboard from '@/components/partners/SharingSettingsDashboard/SharingDashboard.vue';
import DeletePopulationModal from '@/components/populations/DeletePopulationModal.vue';
import IRPActivityTimeline from '@/components/records/IRPActivityTimeline.vue';
import IRPActivityTab from '@/components/records/v2/IRPActivityTab.vue';
import IRPContactsTab from '@/components/records/v2/IRPContactsTab.vue';
import IRPMasterTab from '@/components/records/v2/IRPMasterTab.vue';
import IRPOpportunitiesTab from '@/components/records/v2/IRPOpportunitiesTab.vue';
import IRPOverviewTab from '@/components/records/v2/IRPOverviewTab.vue';
import DeleteReportModal from '@/components/reports/DeleteReportModal.vue';
import DuplicateReportModal from '@/components/reports/DuplicateReportModal.vue';
import ReportNotificationsModalRoute from '@/components/reports/ReportNotificationsModalRoute.vue';
import SharingSettingsPopulation from '@/components/sharing-settings/population-tab/SharingSettingsPopulation.vue';
import UserInfo from '@/components/user/UserInfo.vue';

import Academy from '@/pages/Academy.vue';
import AccessRequested from '@/pages/AccessRequested.vue';
import Analytics from '@/pages/Analytics.vue';
import BillingPage from '@/pages/billing/BillingPage.vue';
import ConnectorSeats from '@/pages/billing/ConnectorSeats.vue';
import ConnectorUpgrade from '@/pages/billing/ConnectorUpgrade.vue';
import EditPaymentModal from '@/pages/billing/EditPaymentModal.vue';
import PurchaseSuccessful from '@/pages/billing/PurchaseSuccessful.vue';
import SelfServe from '@/pages/billing/SelfServe.vue';
import CoSell from '@/pages/co-sell.vue';
import ComingSoon from '@/pages/ComingSoon.vue';
import ConnectDataSource from '@/pages/data-sources/_type/connect.vue';
import DynamicsPickCrm from '@/pages/data-sources/dynamics-pick-crm.vue';
import OauthReturn from '@/pages/data-sources/feed/DataSourceOauthReturn.vue';
import FileUploads from '@/pages/data-sources/FileUploads.vue';
import GoogleSheets from '@/pages/data-sources/GoogleSheets.vue';
import MapAEColumns from '@/pages/data-sources/MapAEColumns.vue';
import MapFieldsColumns from '@/pages/data-sources/MapFieldsColumns.vue';
import OfflinePartnerGoogleSheetsConnect from '@/pages/data-sources/OfflinePartnerGoogleSheetsConnect.vue';
import DataSources from '@/pages/data-sources.vue';
import DormantCompany from '@/pages/dormant-company.vue';
import ForgotPassword from '@/pages/forgot-password.vue';
import PublicInvite from '@/pages/i/_code.vue';
import IframeLogin from '@/pages/IframeLogin.vue';
import OAuthApplicationsCreate from '@/pages/integrations/create.vue';
import ViewInvite from '@/pages/invites/ViewInvite.vue';
import LinkAccounts from '@/pages/link-accounts.vue';
import Login from '@/pages/login.vue';
import MaintenanceMode from '@/pages/MaintenanceMode.vue';
import Notifications from '@/pages/notifications.vue';
import OAuthCallback from '@/pages/oauth/callback.vue';
import ApiKeysPage from '@/pages/organization/ApiKeysPage.vue';
import OrganizationSettings from '@/pages/organization/settings.vue';
import Overlaps from '@/pages/overlaps.vue';
import AcceptPublicInvite from '@/pages/partners/public-invite.vue';
import PartnerstackCallback from '@/pages/partnerstack/callback.vue';
import Populations from '@/pages/populations/Populations.vue';
import PopulationSharingSettings from '@/pages/populations/sharing/PopulationSharingSettings.vue';
import IndividualRecordPage from '@/pages/records/IndividualRecordPage.vue';
import IndividualRecordPageV2 from '@/pages/records/IndividualRecordPageV2.vue';
import IndividualRecordUniversal from '@/pages/records/IndividualRecordUniversal.vue';
import RegisterOrSetup from '@/pages/register/RegisterOrSetup.vue';
import SeatRequestPending from '@/pages/register/SeatRequestPending.vue';
import FolderPage from '@/pages/reports/folders/FolderPage.vue';
import DeleteRoleModal from '@/pages/roles/_id/delete.vue';
import CreateRole from '@/pages/roles/create.vue';
import EditRole from '@/pages/roles/EditRolePage.vue';
import RoleDetails from '@/pages/roles/RoleDetails.vue';
import Roles from '@/pages/roles.vue';
import IndividualListPage from '@/pages/shared-list/IndividualListPage.vue';
import SharedList from '@/pages/shared-list/List.vue';
import SharingSettings from '@/pages/SharingSettings.vue';
import SlackCallback from '@/pages/slack/callback.vue';
import EditUserModal from '@/pages/team/_id/EditUser.vue';
import RemoveUser from '@/pages/team/_id/RemoveUser.vue';
import RevokeInviteModal from '@/pages/team/_id/RevokeInviteModal.vue';
import EditUsersModal from '@/pages/team/EditUsers.vue';
import InviteTeamMember from '@/pages/team/InviteTeamMember.vue';
import RemoveUsersModal from '@/pages/team/RemoveUsers.vue';
import TeamPage from '@/pages/team/TeamPage.vue';
import SunsetThreads from '@/pages/threads/SunsetThreads.vue';
import UserSettings from '@/pages/user/UserSettings.vue';
import VerifyCompany from '@/pages/verify-company.vue';
import VerifyEmail from '@/pages/verify-email.vue';

import useSeats from '@/composables/useSeats';
import { FEATURE_FLAG } from '@/constants/feature_flags';
import { COPILOT_BASE_PATH, SALES_INTEL_BASE_PATH } from '@/constants/router';
import { ls } from '@/local_storage';
import {
  useAttributionStore,
  useBillingStore,
  useFeatureFlagStore,
  useFlashesStore,
  usePartnersStore,
  usePopulationsStore,
  useRolesStore,
} from '@/stores';
import { isOpenDataPopulation } from '@/types/populations';
import { isOrgInSmartOnboardingTestGroup } from '@/utils/abTestGate';
import { beforeEnterMain, handleLogout, routingOverride } from '@/utils/router';

import DefineDataSharingModal from './components/dash/newOnboarding/DefineDataSharingModal.vue';
import IntroVideoModal from './components/dash/newOnboarding/IntroVideoModal.vue';
import GsheetGeneralSettingsModal from './components/data-sources/GsheetGeneralSettingsModal.vue';
import CrossbeamCopilotSettingsDrawer from './components/integrations/CrossbeamCopilotSettingsDrawer.vue';
import IntegrationSettingsDrawer from './components/integrations/IntegrationSettingsDrawer.vue';
import PopulationModal from './components/populations/population-modal/PopulationModal.vue';
import ShareReportModal from './components/reports/ShareReportModal.vue';
import useMinimalApp from './composables/useMinimalApp';
import { BASE_ROUTES, CHILD_ROUTES } from './constants/routes';
import Lists from './pages/Lists.vue';
import { LOGIN_POPUP_PARAM } from './utils';
const AccountMapping = () => import('@/pages/AccountMapping.vue');

const DealNavigatorPage = () =>
  import('@/components/sales/DealNavigator/components/DealNavigatorPage.vue');

const ApplicationLayout = () =>
  import('@/components/layout/ApplicationLayout.vue');
const BareLayout = () => import('@/components/layout/BareLayout.vue');

const NotFound = () => import('@/pages/not-found.vue');
const LoggedOut = () => import('@/pages/logged-out.vue');
const OauthRedirect = () => import('@/pages/OauthRedirect.vue');

const AgentsPage = () => import('@/pages/AgentsPage.vue');
const AgentModal = () => import('@/components/agents/AgentModal.vue');
const DeleteAgentModal = () =>
  import('@/components/agents/DeleteAgentModal.vue');

const OnboardingPage = () => import('@/pages/Onboarding.vue');
const NoOrg = () => import('@/pages/no-org.vue');

const PartnerPageTwo = () => import('@/pages/Partners.vue');
const PartnerDetailsPage = () =>
  import(
    '@/pages/partners/PartnerDetailsPage/components/PartnerDetailsPage.vue'
  );
const ProposalsPreAcceptance = () =>
  import('@/pages/partners/pre-acceptance.vue');
const AcceptInviteModal = () =>
  import('@/pages/partners/AcceptInvite/components/AcceptInviteModal.vue');
const ProposalWrapper = () =>
  import('@/components/partners/AddPartner/ProposalWrapper.vue');
const PartnersTableEditModal = () =>
  import('@/components/partners/PartnersTableEditModal.vue');

const Reports = () => import('@/pages/reports.vue');
const CreateReportModal = () => import('@/pages/reports/CreateReportModal.vue');
const ReportDetail = () => import('@/pages/reports/report-detail.vue');
const BittsPlayground = () => import('@/pages/bitts-playground.vue');
// Pages
const AttributionPage = () => import('@/pages/AttributionPage.vue');
const AttributionDrawer = () =>
  import('@/components/attribution/AttributionDrawer.vue');
const AttributionSettingsModal = () =>
  import('@/components/attribution/AttributionSettingsModal.vue');
const IntegrationsPage = () => import('@/pages/IntegrationsPage.vue');
const PerformanceDashboard = () =>
  import('@/pages/performance-dashboard/PerformanceDashboard.vue');
const PartnerTrackerPage = () => import('@/pages/PartnerTrackerPage.vue');
const PendingRequestsPage = () => import('@/pages/PendingRequestsPage.vue');
const LabsPage = () => import('@/pages/LabsPage.vue');

export const createRouter = (store) => {
  const { hasFeatureFlag } = useFeatureFlagStore();
  const billingStore = useBillingStore();
  const flashesStore = useFlashesStore();
  const attributionStore = useAttributionStore();

  const { blockSalesSeatsPPV5 } = useSeats();

  const hasAttributionPage = store.hasScope('read:attribution');
  const hasWriteIntegrations = store.hasScope('write:integrations');
  const hasAttributionFullAccess =
    attributionStore.hasAttributionAccess &&
    store.hasScope('write:attribution');

  const guardByFlag = (flag, component, fallback) => (to, _from, next) => {
    const match = to.matched.find(
      (m) =>
        m.components?.default === component ||
        m.components?.default === fallback,
    );
    if (match) {
      match.components.default = hasFeatureFlag(flag) ? component : fallback;
    }
    next();
  };

  const swapRecordShell = guardByFlag(
    FEATURE_FLAG.TEMP_IRP_V2,
    IndividualRecordPageV2,
    IndividualRecordPage,
  );

  /* Picks the record page shell and keeps its tab routes consistent with the
     flag: on the flag the bare record path redirects to the default tab, off it
     the v2-only tabs have no legacy counterpart so they redirect back to the
     record page. */
  function guardIrpV2(to, from, next) {
    swapRecordShell(to, from, () => {
      const isV2 = hasFeatureFlag(FEATURE_FLAG.TEMP_IRP_V2);
      const isBareRecord = to.name === 'individual_record';
      if (isV2 && isBareRecord) {
        return next({
          name: 'individual_record_overview',
          params: to.params,
          query: to.query,
        });
      }
      if (!isV2 && !isBareRecord) {
        return next({
          name: 'individual_record',
          params: to.params,
          query: to.query,
        });
      }
      next();
    });
  }

  const { isMinimalView } = useMinimalApp();

  const showIframeLogin = () => {
    const query = new URLSearchParams(window.location.search);
    return isMinimalView && !query.has(LOGIN_POPUP_PARAM);
  };

  const denyAccess = (to) => {
    const firstChild = to.matched[1].components;
    firstChild.overwritten = firstChild.default;
    firstChild.default = AccessDenied;
  };
  const requireScope = (scope) => (to, _from, next) => {
    if (!store.hasScope(scope)) {
      denyAccess(to);
    }
    next();
  };
  const requireAgentWriteAccess = (to, _from, next) => {
    if (!store.hasScope('write:agents')) {
      denyAccess(to);
      return next();
    }
    if (billingStore.isFreeTier) return next({ name: 'agents' });
    return next();
  };
  const checkRedirectWithNewDataShare = (to, _from, next) => {
    if (to.query.tab === 'sharing') {
      next({
        name: 'partnership-settings',
        params: {
          tab: 'sharing-settings',
          partner_org_id: to.params.partner_org_id,
        },
      });
    } else {
      next();
    }
  };
  const checkInvitesIfOrgHasFailed = (to, from, next) => {
    if (store.orgMarkedAsFailed) {
      checkPendingInvitations(to, from, next);
    } else {
      next();
    }
  };
  const checkPendingInvitations = (to, from, next) => {
    const invitation = store.getPendingInvitation;
    if (invitation) {
      // If it's an SSO invite, redirect to SSO login instead of showing the invite page
      if (invitation.is_sso) {
        next({
          name: 'login',
          query: { sso: invitation.sso_id },
        });
      } else {
        next({ name: 'view_invite', params: { code: invitation.invite_code } });
      }
    } else {
      tryAccountLinking(to, from, next);
    }
  };

  function checkPendingSeatRequestsAndInvitations(to, from, next) {
    if (!store.userNeedsToRegister) {
      next();
      return;
    }
    const seatRequest = store.getPendingSeatRequest;
    if (seatRequest) {
      next({
        name: 'invite-requests',
        params: { invite_request_uuid: seatRequest.id },
      });
    } else {
      return checkPendingInvitations(to, from, next);
    }
  }

  const tryAccountLinking = (to, from, next) => {
    const query = { next: to.fullPath };
    if (store.userCanTryToLinkAccounts && from.name !== 'link-accounts') {
      next({ name: 'link-accounts', query });
    } else {
      next();
    }
  };
  const companySetupIfLoggedIn = (_, from, next) => {
    if (store.isLoggedIn && from.name !== 'register') {
      next({ name: 'company_setup' });
    } else {
      next();
    }
  };
  const enforceAuthentication = async (to, from, next) => {
    const nextRoute = await routingOverride({ to, from, store });
    if (nextRoute) {
      const query = { next: to.fullPath, ...nextRoute.query };
      next({ name: nextRoute.name, query });
    } else {
      next();
    }
  };

  const requireWriteIntegrationsAccess = (to, from, next) => {
    hasWriteIntegrations ? next() : next({ name: 'integrations' });
  };

  const dataTemplatesRoute = ({ name, path, props }) => ({
    name,
    path,
    component: DataTemplates,
    props: (route) => ({
      feedId: parseInt(route.params.id),
      customizing: Boolean(route.query.customizing),
      closeRoute: route.query.closeRoute,
      ...props,
    }),
    beforeEnter: requireScope('write:data-sources'),
  });

  const ONBOARDING_ROUTES = [
    {
      name: 'onboarding',
      path: '/onboarding',
      component: OnboardingPage,
      beforeEnter: (_to, _from, next) => {
        if (store.hasIntegrationUserRole) {
          next({ path: '/data-sources' });
        } else if (store.currentOrg?.setup_menu_hidden) {
          next({ name: 'partners' });
        } else {
          next();
        }
      },
      children: [
        {
          name: 'onboarding_user_info',
          path: 'edit-user',
          component: UserInfo,
        },
        {
          name: 'onboarding_intro_video',
          path: 'intro-video',
          component: IntroVideoModal,
        },
        {
          name: 'onboarding_book_meeting',
          path: 'book-meeting',
          component: BookMeetingModal,
        },
        {
          name: 'onboarding_invite_partner',
          path: 'invite-partner',
          component: InvitePartnerModal,
        },
        {
          name: 'onboarding_invite_crm_admins',
          path: 'invite-crm-admins',
          component: InviteCrmAdminsModal,
        },
        {
          name: 'onboarding_choose_data_source',
          path: 'choose-data-source',
          component: ChooseDataSource,
        },
        {
          name: 'onboarding_file_uploads',
          path: 'file-uploads',
          component: FileUploads,
        },
        dataTemplatesRoute({
          name: 'onboarding-data-templates',
          path: 'feed/:id/setup',
          props: {
            closeRoute: '/onboarding',
          },
        }),
        {
          /* Returning from successful oauth to data source */
          name: 'onboarding-data-sources-id',
          path: 'feed/:id',
          component: OauthReturn,
          props: (route) => ({
            feedId: parseInt(route.params.id),
            closeDestination: 'onboarding-google-sheets',
            isOnboarding: true,
          }),
        },
        {
          name: 'onboarding-google-sheets',
          path: 'google-sheets',
          component: GoogleSheets,
          props: {
            cancelDestination: 'onboarding',
          },
        },
        {
          name: 'onboarding-data-sources-connect',
          path: ':type/connect',
          component: ConnectDataSource,
          beforeEnter: requireScope('write:data-sources'),
          props: {
            closeRoute: 'onboarding',
          },
        },
        {
          name: 'onboarding_accept_proposal',
          path: 'accept',
          component: AcceptInviteModal,
          children: [],
        },
        {
          name: 'onboarding_define_populations',
          path: 'define-populations',
          component: () =>
            import(
              '@/components/dash/newOnboarding/DefinePopulationsModal.vue'
            ),
          beforeEnter: requireScope('write:data-sources'),
          children: [
            {
              name: 'onboarding-edit-population',
              path: 'edit/:population_id',
              component: PopulationModal,
              props: (route) => ({
                populationId: parseInt(route.params.population_id),
              }),
            },
            {
              name: 'onboarding-create-population',
              path: 'create',
              component: PopulationModal,
            },
          ],
        },
        {
          name: 'onboarding_review_population',
          path: 'review-population/:population_id',
          component: PopulationModal,
          beforeEnter: requireScope('write:data-sources'),
        },
        {
          name: 'onboarding_create_population_smart',
          path: 'create-population',
          component: PopulationModal,
          beforeEnter: requireScope('write:data-sources'),
        },
        {
          name: 'onboarding_data_sharing',
          path: 'data-sharing',
          component: DefineDataSharingModal,
          children: [],
        },
        {
          name: 'onboarding-dynamics-pick-crm',
          path: 'dynamics-pick-crm',
          component: DynamicsPickCrm,
          props: (route) => ({
            instances: JSON.parse(route.query.instances),
          }),
          beforeEnter(to, _, next) {
            const instances = to.query.instances
              ? JSON.parse(to.query.instances)
              : null;
            if (!instances || !instances.length === 0) {
              /* Either the user refreshes the page before picking a source,
          or they don't have any CRMs in their MD account */
              flashesStore.addErrorFlash({
                message:
                  'There was an issue connecting to your Microsoft Dynamics account',
              });
              next({ name: 'data-sources' });
            } else {
              next();
            }
          },
        },
        {
          name: 'onboarding_accept_public_invite',
          path: 'public-invite',
          component: AcceptPublicInvite,
          beforeEnter(to, _from, next) {
            if (!requireScope('write:partnerships')) denyAccess(to);
            const lsPublicInviteCode = ls.publicInvite.get()?.code;
            if (lsPublicInviteCode === store.currentOrg.public_invite_code) {
              next({ name: 'onboarding' });
            } else if (
              hasFeatureFlag(FEATURE_FLAG.TEMP_NEW_ONBOARDING_SMART) &&
              isOrgInSmartOnboardingTestGroup(store.currentOrg?.id) &&
              ls.acceptedInviteSender.get()?.orgId !== store.currentOrg?.id &&
              ls.publicInviteSentOrg.get()?.orgId !== store.currentOrg?.id
            ) {
              next({ name: 'onboarding' });
            } else {
              next();
            }
          },
        },
      ],
    },
  ];

  const routerConfig = {
    history: createWebHistory('/'),
    /*
     * FULL WIDTH LAYOUT -- UNAUTHENTICATED ROUTES
     */
    routes: [
      {
        name: 'main',
        path: '/',
        beforeEnter(to, from, next) {
          beforeEnterMain(to, from, next, store);
        },
      },
      {
        path: '/',
        component: BareLayout,
        children: [
          {
            name: 'verify_email',
            path: 'verify-email',
            component: VerifyEmail,
            props: (route) => ({ email: route.query.email }),
          },
          {
            name: 'partners_pre_acceptance',
            path: 'partners/pre-acceptance',
            component: ProposalsPreAcceptance,
          },
          {
            name: 'view_invite',
            path: 'invites/:code',
            beforeEnter: tryAccountLinking,
            component: ViewInvite,
          },
          {
            // The switch_org route doesn't need to be authenticated primarily
            // because the user may be coming from the admin panel and we can
            // go ahead and set the org context before potentially asking the
            // user to login. In other words, if the user is not logged in and
            // they hit this route, we'll first set the org in local storage,
            // then reload the page, then the user will be asked to log in and
            // they'll already be targeting the org they want. We also want
            // this route to not pass through the "userNeedsToRegister" check
            // which happens for full-fledged application routes because the
            // user may have just registered and the pinia store might not have
            // information about the org, thus thinking they need to register
            // when they just have
            name: 'switch_org',
            path: '/switch-org',
            beforeEnter(to) {
              ls.orgId.set(to.query.organization_id);

              // Validate the next URL to prevent open redirects
              const nextUrl = to.query.next;
              if (nextUrl) {
                try {
                  const url = new URL(nextUrl, window.location.origin);
                  // Only allow redirects to same origin or crossbeam.com domain
                  if (
                    url.origin === window.location.origin ||
                    url.hostname.endsWith('.crossbeam.com')
                  ) {
                    window.location.replace(nextUrl);
                    return;
                  }
                } catch (e) {
                  // Invalid URL, fall back to home
                }
              }
              window.location.replace('/');
            },
            component: h('div'),
          },
          {
            name: 'register-public-params',
            path: 'register/:invitingOrgString/:inviteNextUrl',
            beforeEnter: companySetupIfLoggedIn,
            component: RegisterOrSetup,
            /*
             * Note we never use this pattern of passing props via router
             * We are passing invitingOrgString via route props via query params, see:
             * https://router.vuejs.org/guide/essentials/passing-props.html#boolean-mode
             * to simplify the layouts. It was originally forcing the RegistrationForm
             * into a layout that didn't match.
             */
            props: true,
          },
          {
            name: 'register-public',
            path: 'register',
            beforeEnter: companySetupIfLoggedIn,
            component: RegisterOrSetup,
            props: true,
          },
          {
            name: 'error',
            path: '/not_found',
            component: NotFound,
          },
          {
            name: 'logged_out',
            path: '/logged-out',
            component: LoggedOut,
          },
          {
            name: 'logout',
            path: '/logout',
            beforeEnter(_to, _from, _next) {
              handleLogout('/logged-out');
            },
          },
          {
            name: 'academy',
            path: '/academy/login',
            component: Academy,
          },
          {
            path: '/',
            name: 'maintenance_mode',
            component: MaintenanceMode,
          },
          {
            name: 'oauth_redirect',
            path: '/oauth-redirect',
            component: OauthRedirect,
          },
          {
            name: 'custom-register',
            path: '/i/:code',
            component: PublicInvite,
          },
          {
            /* Guard in case of nav within Crossbeam-web. Redirect to Copilot */
            name: 'sales_intel',
            path: `${SALES_INTEL_BASE_PATH}/:pathMatch(.*)*`,
            beforeEnter: (to) => {
              // Old sales-intel links need to be redirected to copilot
              const newTo = to.fullPath.replace(
                SALES_INTEL_BASE_PATH,
                COPILOT_BASE_PATH,
              );
              window.location.replace(newTo);
            },
            component: { template: '<div></div>' },
          },
          {
            /* Guard in case of nav within Crossbeam-web. Redirect to Copilot */
            name: 'copilot_view',
            path: `${COPILOT_BASE_PATH}/:pathMatch(.*)*`,
            beforeEnter: (to) => {
              window.location.replace(to.fullPath);
            },
            component: { template: '<div></div>' },
          },
        ],
      },
      /*
       * HALF WIDTH LAYOUT -- UNAUTHENTICATED ROUTES
       */
      {
        path: '/',
        component: BareLayout,
        children: [
          {
            name: 'login',
            path: 'login',
            beforeEnter(to, _from, next) {
              // Let the user access the SSO login page even if they are logged
              if (store.isLoggedIn && !to.query.sso) {
                window.location.replace('/');
              } else {
                next();
              }
            },
            component: showIframeLogin() ? IframeLogin : Login,
          },
          {
            name: 'forgot-password',
            path: 'forgot-password',
            component: ForgotPassword,
          },
          {
            name: 'link-accounts',
            path: 'link-accounts',
            component: LinkAccounts,
          },
        ],
      },
      /*
       * AUTHENTICATED, NON-APPLICATION ROUTES
       * These routes are restricted in the same way the AUTHENTICATED APPLICATION ROUTES are,
       * but they do not use use the full ApplicationLayout.
       */
      {
        path: '/',
        beforeEnter(to, _from, next) {
          if (!store.isLoggedIn) {
            next({ name: 'login', query: { next: to.fullPath } });
          } else {
            next();
          }
        },
        component: BareLayout,
        children: [
          {
            name: 'no_org',
            path: 'no-org',
            beforeEnter: checkPendingInvitations,
            component: NoOrg,
          },
          {
            name: 'coming_soon',
            path: 'coming-soon',
            component: ComingSoon,
          },
          {
            name: 'verify_company',
            path: 'verify-company',
            beforeEnter: checkInvitesIfOrgHasFailed,
            component: VerifyCompany,
          },
          {
            name: 'dormant_company',
            path: 'dormant-company',
            component: DormantCompany,
          },
          {
            name: 'invite-requests',
            path: '/invite-requests/:invite_request_uuid',
            beforeEnter: checkPendingInvitations,
            component: AccessRequested,
            props: (route) => ({ uuid: route.params.invite_request_uuid }),
          },
          {
            name: 'company_setup',
            path: 'company-setup',
            beforeEnter: checkPendingSeatRequestsAndInvitations,
            component: RegisterOrSetup,
          },
          {
            name: 'seat_request_pending',
            path: 'seat-request-pending',
            component: SeatRequestPending,
          },
        ],
      },
      /*
       *  AUTHENTICATED APPLICATION ROUTES
       *  The routes under this parent route all require an authenticated,
       *  registered user. This is the main application section.
       *
       *  Unauthenticated users will be sent to the login page. Unregistered
       *  users will be sent to the registration page. Otherwise, the request
       *  will be allowed.
       */
      {
        path: '/',
        beforeEnter: enforceAuthentication,
        component: ApplicationLayout,
        props: (route) => ({
          fullWidth: fullWidthAuthenticatedRoutes.some((path) =>
            route.fullPath.startsWith(path),
          ),
        }),
        children: [
          {
            // TODO: DELETE THIS ROUTING AND COMPONENT ONCE MERGED IN NEXT FEATURE TICKET
            name: 'partner-score-showroom',
            path: 'partner-score-showroom',
            component: () =>
              import('@/components/partners/PartnerScoreTagShowroom.vue'),
            beforeEnter: (_to, _from, next) => {
              hasFeatureFlag(FEATURE_FLAG.TEMP_PARTNER_SCORE_ACCESS)
                ? next()
                : next({ name: 'not_found' });
            },
          },
          {
            name: BASE_ROUTES.ANALYTICS,
            path: 'analytics',
            component: Analytics,
            beforeEnter(_to, _from, next) {
              hasFeatureFlag(FEATURE_FLAG.OMNI_ENABLED)
                ? next()
                : next({ name: 'not_found' });
            },
          },
          {
            name: 'agents',
            path: 'agents',
            component: AgentsPage,
            beforeEnter(to, _from, next) {
              if (!hasFeatureFlag(FEATURE_FLAG.TEMP_AGENTS))
                return next({ name: 'not_found' });
              if (!store.hasScope('read:agents')) denyAccess(to);
              next();
            },
            children: [
              {
                name: 'agents.edit',
                component: AgentModal,
                path: ':id',
                beforeEnter: requireAgentWriteAccess,
              },
              {
                name: 'agents.create',
                component: AgentModal,
                path: 'create',
                beforeEnter: requireAgentWriteAccess,
              },
              {
                name: 'agents.delete',
                component: DeleteAgentModal,
                path: 'delete/:id',
                beforeEnter: requireAgentWriteAccess,
              },
            ],
          },
          {
            name: BASE_ROUTES.ATTRIBUTION,
            path: 'attribution',
            component: AttributionPage,
            beforeEnter(_to, _from, next) {
              hasAttributionPage ? next() : next({ name: 'not_found' });
            },
            children: [
              {
                name: CHILD_ROUTES.attribution.ATTRIBUTE,
                path: ':master_id/:opportunity_id/attribute',
                component: AttributionDrawer,
                beforeEnter(_to, _from, next) {
                  hasAttributionFullAccess
                    ? next()
                    : next({ name: 'not_found' });
                },
              },
              {
                name: CHILD_ROUTES.attribution.ATTRIBUTION_TIMELINE,
                path: ':master_id/:opportunity_id/timeline',
                component: AttributionDrawer,
                beforeEnter(_to, _from, next) {
                  hasAttributionFullAccess &&
                  store.hasScope('read:activity-timeline')
                    ? next()
                    : next({ name: 'not_found' });
                },
              },
              {
                name: CHILD_ROUTES.attribution.ATTRIBUTION_SETTINGS,
                path: 'settings',
                component: AttributionSettingsModal,
              },
            ],
          },
          {
            name: BASE_ROUTES.ECOSYSTEM_INSIGHTS,
            path: 'measure/ecosystem/:tab?',
            component: PerformanceDashboard,
            beforeEnter(_to, _from, next) {
              !store.hasScope('read:reports')
                ? next({ name: 'not_found' })
                : next();
            },
            children: [
              {
                name: CHILD_ROUTES.ecosystem_insights
                  .ECOSYSTEM_INSIGHTS_TIMELINE,
                path: ':master_id/:opportunity_id/timeline',
                component: AttributionDrawer,
                beforeEnter(_to, _from, next) {
                  hasAttributionFullAccess
                    ? next()
                    : next({ name: 'not_found' });
                },
              },
              {
                name: CHILD_ROUTES.ecosystem_insights
                  .ECOSYSTEM_INSIGHTS_ATTRIBUTE,
                path: ':master_id/:opportunity_id/attribute',
                component: AttributionDrawer,
                beforeEnter(_to, _from, next) {
                  hasAttributionFullAccess
                    ? next()
                    : next({ name: 'not_found' });
                },
              },
            ],
          },
          {
            name: 'notifications',
            path: 'notifications',
            component: Notifications,
          },
          {
            name: BASE_ROUTES.REPORTS,
            path: 'reports',
            component: Reports,
            beforeEnter(to, _from, next) {
              if (to.path === '/reports/create') {
                next({ name: 'lists.create', query: to.query });
              } else {
                next({ name: 'lists' });
              }
            },
            children: [
              {
                name: CHILD_ROUTES.reports.REPORTS_DUPLICATE,
                path: ':id/duplicate',
                component: DuplicateReportModal,
                meta: { modal: true },
              },
              {
                name: CHILD_ROUTES.reports.REPORTS_DELETE,
                path: ':id/delete',
                component: DeleteReportModal,
                meta: { modal: true },
              },
              {
                name: CHILD_ROUTES.reports.REPORTS_NOTIFICATIONS,
                path: ':id/notifications',
                component: ReportNotificationsModalRoute,
                meta: { modal: true },
              },
              {
                name: 'reports.create',
                path: '/reports/create',
                component: CreateReportModal,
                meta: { modal: true },
              },
              {
                path: '/reports/account-mapping/create',
                redirect: (to) => ({
                  path: '/lists/create',
                  query: to.query,
                }),
              },
              {
                name: 'reports.share',
                path: 'share',
                component: ShareReportModal,
                meta: { modal: true },
              },
            ],
          },
          {
            name: BASE_ROUTES.REPORT_FOLDER,
            path: '/reports/folders/:folder_id',
            component: FolderPage,
            children: [
              {
                name: CHILD_ROUTES.folder.REPORTS_DUPLICATE,
                path: 'duplicate',
                component: DuplicateReportModal,
                meta: { modal: true },
              },
              {
                name: CHILD_ROUTES.folder.REPORTS_DELETE,
                path: 'delete',
                component: DeleteReportModal,
                meta: { modal: true },
              },
              {
                name: CHILD_ROUTES.folder.REPORTS_NOTIFICATIONS,
                path: 'notifications',
                component: ReportNotificationsModalRoute,
                meta: { modal: true },
              },
              {
                name: 'folder.share',
                path: 'share',
                component: ShareReportModal,
                meta: { modal: true },
              },
            ],
          },
          {
            name: 'view_report',
            path: '/reports/view',
            component: ReportDetail,
          },
          {
            name: 'edit_report',
            path: '/reports/:report_id',
            component: ReportDetail,
            children: [
              {
                name: 'edit_report.share',
                path: 'share',
                component: ShareReportModal,
              },
            ],
          },
          {
            name: 'lists',
            path: '/lists',
            component: Lists,
            children: [
              {
                name: 'lists.create',
                path: 'create',
                component: CreateReportModal,
              },
              {
                name: 'lists.notifications',
                path: 'notifications',
                component: ReportNotificationsModalRoute,
                meta: { modal: true },
              },
              {
                name: 'lists.delete',
                path: ':id/delete',
                component: DeleteReportModal,
                meta: { modal: true },
              },
              {
                name: 'lists.duplicate',
                path: ':id/duplicate',
                component: DuplicateReportModal,
                meta: { modal: true },
              },
              {
                name: 'lists.share',
                path: 'share',
                component: ShareReportModal,
                meta: { modal: true },
              },
            ],
          },
          {
            name: 'generate-pipeline',
            path: 'generate-pipeline',
            component: DealNavigatorPage,
          },
          {
            name: BASE_ROUTES.DEAL_NAVIGATOR,
            path: '/deal-navigator',
            component: DealNavigatorPage,
            redirect: '/deal-navigator/close-deals',
            children: [
              {
                name: 'deal-navigator-close-deals',
                path: 'close-deals',
                component: DealNavigatorPage,
              },
              {
                name: 'deal-navigator-generate-pipeline',
                path: 'generate-pipeline',
                component: DealNavigatorPage,
                beforeEnter(to, _from, next) {
                  next({ path: '/generate-pipeline', query: to.query });
                },
              },
            ],
          },
          {
            name: 'home_account_mapping',
            path: '/account-mapping',
            component: AccountMapping,
            children: [
              {
                name: 'home_account_mapping.create',
                path: 'create',
                component: CreateReportModal,
              },
            ],
          },
          {
            name: 'home',
            path: '/home',
            component: h('div'),
            beforeEnter: (to, from, next) => {
              if (to.name !== BASE_ROUTES.DEAL_NAVIGATOR) {
                const hasSalesOnlyRole = store.hasSalesOnlyRole;
                const { state: _state, ...query } = to.query;
                return next({
                  query,
                  path: store.hasIntegrationUserRole
                    ? '/data-sources'
                    : hasSalesOnlyRole || isMinimalView
                      ? '/deal-navigator'
                      : '/partners',
                });
              }
              next();
            },
          },
          {
            name: 'labs',
            path: 'labs',
            component: LabsPage,
            beforeEnter(_, __, next) {
              if (billingStore.isFreeTier) next({ name: 'not_found' });
              else next();
            },
          },
          ...ONBOARDING_ROUTES,
          // -----------------
          //   Home
          // -----------------
          {
            path: '/dashboard',
            redirect: (to) => ({ name: 'home', query: to.query }),
          },

          // -----------------
          //  populations
          // -----------------
          {
            name: 'populations',
            path: '/populations',
            component: Populations,
            children: [
              {
                name: 'create_population',
                path: '/populations/create',
                component: PopulationModal,
                beforeEnter(to, from, next) {
                  if (to.query?.offlinePartnerId)
                    return requireScope('write:offline-partners')(
                      to,
                      from,
                      next,
                    );
                  return requireScope('write:populations')(to, from, next);
                },
                children: [
                  dataTemplatesRoute({
                    name: 'edit-new-population-data',
                    path: ':id/setup',
                  }),
                ],
              },
              {
                name: 'view_population',
                path: '/populations/:population_id(\\d+)/view',
                component: PopulationModal,
                async beforeEnter(to, from, next) {
                  if (store.hasScope('write:populations')) return next();
                  const populationsStore = usePopulationsStore();
                  await populationsStore.readySync;
                  const popId = Number(to.params.population_id);
                  const pop = populationsStore.getPopulationById(popId);
                  if (isOpenDataPopulation(pop)) return next();
                  denyAccess(to);
                  next();
                },
              },
              {
                name: 'edit_population',
                path: '/populations/:population_id(\\d+)/edit',
                component: PopulationModal,
                beforeEnter(to, from, next) {
                  return requireScope('write:populations')(to, from, next);
                },
                children: [
                  dataTemplatesRoute({
                    name: 'edit-population-data',
                    path: ':id/setup',
                  }),
                  {
                    name: 'delete-population-modal',
                    path: 'delete',
                    component: DeletePopulationModal,
                  },
                ],
              },

              {
                name: 'populations.sharing',
                path: '/populations/sharing/:population_id(\\d+)',
                component: PopulationSharingSettings,
                children: [],
              },
            ],
          },

          // -----------------
          //  shared-list
          // -----------------

          {
            name: 'collaborate',
            path: '/collaborate',
            component: SharedList,
            beforeEnter(_to, _from, next) {
              next({ name: 'lists' });
            },
          },
          {
            name: 'collaborate_list',
            path: '/collaborate/:id',
            component: IndividualListPage,
            beforeEnter(to, from, next) {
              requireScope('write:lists')(to, from, next);
            },
            props: (route) => ({ listId: route.params.id }),
          },
          // -----------------
          //  threads
          // -----------------
          {
            name: 'threads',
            path: '/threads',
            beforeEnter(_to, _from, next) {
              next({ name: 'sunset-threads' });
            },
          },
          {
            name: 'thread',
            path: '/threads/:thread_id',
            beforeEnter(_to, _from, next) {
              next({ name: 'sunset-threads' });
            },
          },
          {
            name: 'sunset-threads',
            path: '/sunset-threads',
            component: SunsetThreads,
          },
          // -----------------
          //  individual record page
          // -----------------
          {
            name: 'individual_record_universal',
            path: '/records/:context',
            component: IndividualRecordUniversal,
            props: ({ params }) => ({ context: params.context }),
          },
          {
            name: 'individual_record',
            path: '/records/:source_id/:source_primary_key',
            component: IndividualRecordPage,
            beforeEnter: guardIrpV2,
            props: ({ params }) => ({
              sourceId: Number(params.source_id),
              sourcePrimaryKey: params.source_primary_key,
            }),
            children: [
              {
                name: 'individual_record_threads_list',
                path: 'threads',
                beforeEnter(_to, _from, next) {
                  next({ name: 'sunset-threads' });
                },
              },
              {
                name: 'create_individual_record_thread',
                path: 'threads/create',
                beforeEnter(_to, _from, next) {
                  next({ name: 'sunset-threads' });
                },
              },
              {
                name: 'activity_timeline',
                path: 'timeline',
                component: IRPActivityTimeline,
                beforeEnter: [
                  (to, _from, next) => {
                    if (store.hasScope('read:activity-timeline')) next();
                    else denyAccess(to);
                  },
                  guardByFlag(
                    FEATURE_FLAG.TEMP_IRP_V2,
                    IRPActivityTab,
                    IRPActivityTimeline,
                  ),
                ],
              },
              {
                name: 'individual_record_overview',
                path: 'overview',
                component: IRPOverviewTab,
                beforeEnter: guardIrpV2,
              },
              {
                name: 'individual_record_details',
                path: 'details',
                component: IRPMasterTab,
                beforeEnter: guardIrpV2,
              },
              {
                name: 'individual_record_contacts',
                path: 'contacts',
                component: IRPContactsTab,
                beforeEnter: guardIrpV2,
              },
              {
                name: 'individual_record_opportunities',
                path: 'opportunities',
                component: IRPOpportunitiesTab,
                beforeEnter: guardIrpV2,
              },
            ],
          },

          // -----------------
          //  partners
          // -----------------

          {
            name: 'partners',
            path: '/partners',
            component: PartnerPageTwo,
            children: [
              {
                name: 'edit_partner_tags',
                path: ':id/tags',
                beforeEnter: requireScope('write:partnerships'),
                component: PartnersTableEditModal,
              },
              {
                name: 'add_partners_to_tag',
                path: 'tags/:tag_id',
                beforeEnter: requireScope('write:partnerships'),
                component: PartnersTableEditModal,
              },
              {
                name: 'create_proposal',
                path: 'invite',
                component: ProposalWrapper,
                beforeEnter(to, _from, next) {
                  if (
                    store.hasScope('write:partnerships') ||
                    store.hasScope('write:offline-partners')
                  )
                    next();
                  else denyAccess(to);
                },
              },
              {
                name: 'accept_public_invite',
                path: 'public-invite',
                component: AcceptPublicInvite,
                beforeEnter(to, _from, next) {
                  if (!requireScope('write:partnerships')) denyAccess(to);
                  const lsPublicInviteCode = ls.publicInvite.get()?.code;
                  if (
                    lsPublicInviteCode === store.currentOrg.public_invite_code
                  ) {
                    next({ name: 'home' });
                  } else if (
                    !store.currentOrg?.setup_menu_hidden &&
                    hasFeatureFlag(FEATURE_FLAG.TEMP_NEW_ONBOARDING_SMART) &&
                    isOrgInSmartOnboardingTestGroup(store.currentOrg?.id) &&
                    ls.acceptedInviteSender.get()?.orgId !==
                      store.currentOrg?.id &&
                    ls.publicInviteSentOrg.get()?.orgId !== store.currentOrg?.id
                  ) {
                    next({ name: 'onboarding' });
                  } else {
                    next();
                  }
                },
              },
              {
                name: 'accept_proposal',
                path: 'accept',
                component: AcceptInviteModal,
                children: [],
              },
              {
                name: 'partners_proposals_id',
                path: 'proposals/:proposal_id(\\d+)',
                redirect(to) {
                  return {
                    name: 'accept_proposal',
                    query: { proposal_id: to.params.proposal_id },
                  };
                },
              },
            ],
          },
          {
            name: 'partner_details',
            path: '/partners/:partner_org_id(\\d+)',
            component: PartnerDetailsPage,
            async beforeEnter(to, from, next) {
              const partnerStore = usePartnersStore();
              await partnerStore.readySync;
              const partner = partnerStore.getPartnerOrgById(
                to.params?.partner_org_id,
              );
              if (!partner) {
                next({ name: 'not_found' });
                return;
              }
              if (to.query?.offlinePartnerId)
                return requireScope('write:offline-partners')(to, from, next);
              return checkRedirectWithNewDataShare(to, from, next);
            },
            props: (route) => ({
              partnerId: parseInt(route.params.partner_org_id),
            }),
            children: [
              {
                name: 'partner_details_edit_tags',
                path: 'edit-tags',
                component: PartnersTableEditModal,
              },
              {
                name: 'offline_partner_file_upload',
                path: 'add-csv',
                component: FileUploads,
              },
              {
                name: 'offline_partner_google_sheets_connect',
                path: 'connect-google-sheet',
                component: OfflinePartnerGoogleSheetsConnect,
                beforeEnter(_to, _from, next) {
                  if (
                    !hasFeatureFlag(
                      FEATURE_FLAG.TEMP_OFFLINE_PARTNER_GOOGLE_SHEETS,
                    )
                  )
                    return next({ name: 'not_found' });
                  next();
                },
              },
              {
                name: 'offline_partner_google_sheets_setup',
                path: 'add-google-sheet',
                component: GoogleSheets,
                beforeEnter(_to, _from, next) {
                  if (
                    !hasFeatureFlag(
                      FEATURE_FLAG.TEMP_OFFLINE_PARTNER_GOOGLE_SHEETS,
                    )
                  )
                    return next({ name: 'not_found' });
                  next();
                },
              },
              {
                name: 'delete_partner',
                path: 'delete-partnership',
                component: DeletePartnershipModal,
              },
              {
                name: 'offline-file-upload-add-data',
                path: 'file-uploads/add-data/:id',
                component: FileUploads,
                props: (route) => ({ sourceId: parseInt(route.params.id) }),
              },
              {
                name: 'offline-delete-source',
                path: 'source/:source_id/delete',
                component: RemoveSourceModal,
                props: (route) => ({
                  sourceId: parseInt(route.params.source_id),
                }),
              },
              {
                name: 'offline-map-fields-columns',
                path: 'map-fields-columns/:id',
                component: MapFieldsColumns,
                props: (route) => ({
                  accountSourceId: parseInt(route.params.id),
                  cancelDestination: `/partners/${route.params.partner_org_id}`,
                  offlinePartnerUuid: route.query.offlinePartnerUuid ?? null,
                }),
                beforeEnter(_to, _from, next) {
                  next();
                },
              },
              {
                name: 'offline-details-delete-population-modal',
                path: ':population_id/delete',
                component: DeletePopulationModal,
              },
              {
                name: 'offline-create-population',
                path: 'populations/create',
                component: PopulationModal,
                beforeEnter: requireScope('write:offline-partners'),
              },
              {
                name: 'offline-edit-population',
                path: 'populations/:population_id(\\d+)/edit',
                component: PopulationModal,
                beforeEnter: requireScope('write:offline-partners'),
              },
              {
                name: 'offline-view-population',
                path: 'populations/:population_id(\\d+)/view',
                component: PopulationModal,
                beforeEnter: requireScope('write:offline-partners'),
              },
              {
                name: 'partnership-settings',
                path: 'settings/:tab?',
                component: PartnershipSettingsModal,
                children: [],
              },
              {
                name: 'partner_details.report_notifications',
                path: 'reports/:id/notifications',
                component: ReportNotificationsModalRoute,
              },
              {
                name: 'partner_details.report_delete',
                path: 'reports/:id/delete',
                component: DeleteReportModal,
                meta: { modal: true },
              },
              {
                name: 'partner_details.report_duplicate',
                path: 'reports/:id/duplicate',
                component: DuplicateReportModal,
                meta: { modal: true },
              },
              {
                name: 'partner_details.report_share',
                path: 'reports/:id/share',
                component: ShareReportModal,
                meta: { modal: true },
              },
            ],
          },
          {
            name: 'sharing_dashboard',
            path: 'partners/sharing-dashboard',
            component: SharingDashboard,
          },
          {
            name: 'pending_requests',
            path: 'partners/pending-requests',
            component: PendingRequestsPage,
            beforeEnter: (to, from, next) => {
              if (hasFeatureFlag(FEATURE_FLAG.TEMP_PARTNER_TRACKER_ACCESS)) {
                next({
                  name: 'partner_wishlist_requests',
                  query: {
                    ...(to.query.tab && { tab: to.query.tab }),
                    ...(to.query.view && { view: to.query.view }),
                  },
                });
              } else {
                next();
              }
            },
            children: [
              {
                name: 'pending_requests_accept_proposal',
                path: 'accept',
                component: AcceptInviteModal,
                children: [],
              },
            ],
          },
          {
            name: 'partner_wishlist',
            path: '/invitations/partner-wishlist',
            component: PartnerTrackerPage,
            beforeEnter: (to, from, next) => {
              if (!hasFeatureFlag(FEATURE_FLAG.TEMP_PARTNER_TRACKER_ACCESS)) {
                next({ name: 'not_found' });
              } else {
                next();
              }
            },
            children: [
              {
                name: 'partner_wishlist_accept_proposal',
                path: 'accept',
                component: AcceptInviteModal,
                children: [],
              },
            ],
          },
          {
            name: 'partner_wishlist_requests',
            path: '/invitations/requests',
            component: PartnerTrackerPage,
            beforeEnter: (to, from, next) => {
              if (!hasFeatureFlag(FEATURE_FLAG.TEMP_PARTNER_TRACKER_ACCESS)) {
                next({ name: 'not_found' });
              } else {
                next();
              }
            },
            children: [
              {
                name: 'partner_wishlist_requests_accept_proposal',
                path: 'accept',
                component: AcceptInviteModal,
                children: [],
              },
            ],
          },

          // -----------------
          //  data shares
          // -----------------

          {
            name: 'data_shares',
            path: '/data-shares',
            redirect: { name: 'sharing' },
          },

          // -----------------
          //    org settings / team
          // -----------------
          {
            name: 'org_settings',
            path: '/organization/settings',
            component: OrganizationSettings,
          },
          {
            name: 'api_keys',
            path: '/organization/api-keys',
            component: ApiKeysPage,
            beforeEnter(to, from, next) {
              const { hasFeatureFlag } = useFeatureFlagStore();
              if (
                !hasFeatureFlag(FEATURE_FLAG.TEMP_API_KEYS) ||
                !store.hasScope('read:api-keys')
              ) {
                next({ name: 'org_settings' });
              } else {
                next();
              }
            },
          },
          {
            name: 'roles',
            path: '/roles',
            component: Roles,
            children: [
              {
                name: 'create_role',
                path: 'create',
                component: CreateRole,
                beforeEnter: requireScope('write:roles'),
              },
              {
                name: 'edit_role',
                path: ':role_id/edit',
                component: EditRole,
                async beforeEnter(to, from, next) {
                  const { readySync, getRoleById } = useRolesStore();
                  await readySync;
                  const role = getRoleById(to.params.role_id);
                  if (!role.is_editable) {
                    denyAccess(to);
                  }
                  requireScope('write:roles')(to, from, next);
                },
              },
              {
                name: 'role_details',
                path: ':role_id',
                component: RoleDetails,
                beforeEnter: requireScope('write:roles'),
              },
              {
                name: 'delete_role',
                path: ':role_id/delete',
                component: DeleteRoleModal,
                beforeEnter: requireScope('write:roles'),
              },
            ],
          },
          {
            name: 'team',
            path: '/team',
            component: TeamPage,
            children: [
              {
                name: 'invite_user',
                path: 'invite/:invite_request_uuid?',
                component: InviteTeamMember,
                props: (route) => ({
                  inviteRequestId: route.params.invite_request_uuid,
                }),
                beforeEnter(to, _from, next) {
                  if (!store.hasScope('write:members')) {
                    denyAccess(to);
                  }
                  next();
                },
              },
              {
                name: 'remove_user',
                path: ':user_id/remove-user',
                component: RemoveUser,
                beforeEnter: requireScope('write:members'),
                props: (route) => ({ userId: parseInt(route.params.user_id) }),
              },
              {
                name: 'remove_users',
                path: 'remove-users',
                component: RemoveUsersModal,
                beforeEnter: requireScope('write:members'),
              },
              {
                name: 'edit_user',
                path: ':user_id/edit-user',
                component: EditUserModal,
                beforeEnter: requireScope('write:members'),
                props: (route) => ({ userId: parseInt(route.params.user_id) }),
              },
              {
                name: 'edit_users',
                path: 'edit-users',
                component: EditUsersModal,
                beforeEnter: requireScope('write:members'),
              },
              {
                name: 'revoke_invite',
                path: ':user_id/revoke-invite/:email',
                component: RevokeInviteModal,
                beforeEnter: requireScope('write:members'),
                props: (route) => ({
                  userId: parseInt(route.params.user_id),
                  email: route.params.email,
                }),
              },
              {
                name: 'approve_team_seat_request',
                path: 'approve-seat-request',
                component: InviteTeamMember,
                beforeEnter(to, _from, next) {
                  if (!store.hasScope('write:members')) {
                    denyAccess(to);
                  }
                  next();
                },
              },
            ],
          },
          {
            name: 'billing',
            path: '/billing',
            component: BillingPage,
            beforeEnter: requireScope('write:billing'),
            children: [
              {
                name: 'edit-payment',
                path: 'edit-payment',
                component: EditPaymentModal,
                beforeEnter(_, __, next) {
                  const isConnectorTier = billingStore.isConnectorTier;
                  if (!isConnectorTier) next({ name: 'not_found' });
                  else next();
                },
                props: () => ({ successDestination: 'billing' }),
              },
              {
                name: 'billing_mcp_usage',
                path: 'mcp-usage',
                component: CreditUsageModal,
                beforeEnter: guardByFlag(
                  FEATURE_FLAG.TEMP_MCP_METERING_UI,
                  CreditUsageModal,
                  NotFound,
                ),
              },
              {
                name: 'billing_add_credits',
                path: 'add-credits',
                component: CreditPackPurchaseModal,
                beforeEnter(_, __, next) {
                  const canBuyCreditPacks =
                    hasFeatureFlag(
                      FEATURE_FLAG.TEMP_SELF_SERVICE_CREDIT_LIMITS,
                    ) && billingStore.isSupernodeOrEnterpriseTier;
                  if (!canBuyCreditPacks) next({ name: 'not_found' });
                  else next();
                },
              },
            ],
          },
          {
            name: 'self-serve',
            path: 'self-serve',
            beforeEnter: requireScope('write:billing'),
            component: SelfServe,
            children: [
              {
                name: 'self-serve-connector-seats',
                path: 'connector-seats',
                component: ConnectorSeats,
                beforeEnter: (_to, _from, next) => {
                  if (!blockSalesSeatsPPV5.value) {
                    next();
                    return;
                  }
                  next({
                    name: 'team',
                    query: {
                      open_add_seats: true,
                    },
                  });
                },
              },
              {
                name: 'self-serve-purchase-connector',
                path: 'purchase-connector',
                component: ConnectorUpgrade,
              },
              {
                name: 'welcome-to-the-team',
                path: 'purchase-successful',
                component: PurchaseSuccessful,
              },
            ],
          },
          {
            name: 'integrations',
            path: '/integrations',
            component: IntegrationsPage,
            children: [
              {
                name: 'create_oauth_application',
                path: 'create',
                component: OAuthApplicationsCreate,
              },
              {
                name: 'oauth-applications',
                path: 'oauth-applications/:id',
                component: OAuthSettingsDrawer,
              },
              // -----------------
              //  SF Modal
              // -----------------
              {
                name: 'salesforce_push_settings',
                path: 'sf-push/manage',
                component: SalesforceCustomObjectSettingsDrawer,
                beforeEnter: requireWriteIntegrationsAccess,
              },
              // -----------------
              // Copilot Settings Modal
              // -----------------
              {
                name: 'crossbeam_copilot_settings',
                path: 'crossbeam-copilot/:integration/manage',
                component: CrossbeamCopilotSettingsDrawer,
                beforeEnter: requireWriteIntegrationsAccess,
              },
              {
                name: 'snowflake_push_settings',
                path: 'snowflake-push/manage',
                component: SnowflakeIntegrationSettingsDrawer,
                beforeEnter(to, _from, next) {
                  hasWriteIntegrations ? next() : next({ name: 'not_found' });
                },
              },
              {
                name: 'databricks_push_settings',
                path: 'databricks-push/manage',
                component: DatabricksIntegrationSettingsDrawer,
                beforeEnter(to, _from, next) {
                  hasWriteIntegrations ? next() : next({ name: 'not_found' });
                },
              },
              {
                name: 'integration_profile_settings',
                path: ':tray_tag/manage',
                component: IntegrationSettingsDrawer,
                beforeEnter: requireWriteIntegrationsAccess,
              },
            ],
          },
          {
            name: 'default-sharing',
            path: '/default-sharing',
            redirect: { name: 'sharing-settings' },
          },
          {
            name: 'sharing-settings',
            path: '/sharing-settings',
            component: SharingSettings,
            children: [
              {
                name: 'sharing-settings-by-population',
                path: 'population/:population_id',
                component: SharingSettingsPopulation,
              },
            ],
          },
          {
            name: 'sharing_settings_requests',
            path: '/sharing-settings/requests',
            component: SharingSettings,
            beforeEnter: (to, from, next) => {
              if (!hasFeatureFlag(FEATURE_FLAG.TEMP_PARTNER_TRACKER_ACCESS)) {
                next({ name: 'not_found' });
              } else {
                next();
              }
            },
            children: [
              {
                name: 'sharing_settings_requests_accept_proposal',
                path: 'accept',
                component: AcceptInviteModal,
                children: [],
              },
            ],
          },
          {
            name: 'data-sources',
            path: '/data-sources',
            component: DataSources,
            children: [
              {
                name: 'data-sources-connect',
                path: ':type/connect',
                component: ConnectDataSource,
                beforeEnter: requireScope('write:data-sources'),
              },
              {
                name: 'data_sources_jwt_fields',
                path: ':type/connect/jwt',
                component: () =>
                  import('@/components/data-sources/SFDCJwtFields.vue'),
                beforeEnter: requireScope('write:data-sources'),
                props: (route) => ({
                  feedId: route.query.feed_id
                    ? parseInt(route.query.feed_id)
                    : undefined,
                }),
              },
              {
                /* Returning from successful oauth to data source */
                name: 'data-sources-id',
                path: 'feed/:id',
                component: OauthReturn,
                props: (route) => ({ feedId: parseInt(route.params.id) }),
              },
              {
                name: 'gsheet-general-settings',
                path: 'feed/:id/general-settings',
                component: GsheetGeneralSettingsModal,
                beforeEnter: (to, _, next) => {
                  if (store.hasScope('write:data-sources')) {
                    next();
                  } else denyAccess(to);
                },
              },
              {
                name: 'data-sources-settings-new',
                path: 'feed/:id/settings/:tab/:source_id?',
                component: DataSourceSettingsModal,
                beforeEnter: (to, _, next) => {
                  if (store.hasScope('write:data-sources')) {
                    next();
                  } else denyAccess(to);
                },
                props: (route) => ({
                  feedId: parseInt(route.params.id),
                  sourceId: route.params.source_id
                    ? parseInt(route.params.source_id)
                    : undefined,
                }),
                children: [
                  {
                    name: 'delete-data-source',
                    path: 'delete',
                    component: DataSourceDeleteModal,
                    props: (route) => ({
                      feedId: parseInt(route.params.id),
                      sourceId: parseInt(route.params.source_id),
                      cancelDestination: `/data-sources/feed/${route.params.id}/settings/${route.params.tab}/${route.params.source_id ?? ''}`,
                    }),
                  },
                  {
                    name: 'edit-fields',
                    path: 'edit',
                    component: DataTemplates,
                    beforeEnter: async (to, from, next) => {
                      if (
                        to.params.tab === DataSourceSettingsTabType.DATA_IMPORT
                      ) {
                        await next();
                      } else {
                        next({
                          name: 'data-sources-settings-new',
                          params: to.params,
                        });
                      }
                    },
                    props: (route) => ({
                      feedId: parseInt(route.params.id),
                      customizing: Boolean(route.query.customizing),
                      closeRoute: `/data-sources/feed/${route.params.id}/settings/${DataSourceSettingsTabType.DATA_IMPORT}/${route.params.source_id ?? ''}`,
                    }),
                  },
                  {
                    name: 'csv-add-data',
                    path: 'add-data',
                    component: FileUploads,
                    props: (route) => ({
                      sourceId: parseInt(route.params.source_id),
                      cancelDestination: `/data-sources/feed/${route.params.id}/settings/${DataSourceSettingsTabType.GENERAL}/${route.params.source_id ?? ''}`,
                    }),
                  },
                  {
                    name: 'map-ae-columns-settings',
                    path: 'map-columns',
                    component: MapAEColumns,
                    props: (route) => ({
                      sourceId: parseInt(route.params.source_id),
                      cancelDestination: `/data-sources/feed/${route.params.id}/settings/${DataSourceSettingsTabType.GENERAL}/${route.params.source_id ?? ''}`,
                    }),
                  },
                  {
                    name: 'map-fields-columns-settings',
                    path: 'map-fields-columns',
                    component: MapFieldsColumns,
                    props: (route) => ({
                      accountSourceId: parseInt(route.params.source_id),
                      cancelDestination: `/data-sources/feed/${route.params.id}/settings/${DataSourceSettingsTabType.GENERAL}/${route.params.source_id ?? ''}`,
                    }),
                    beforeEnter(_to, _from, next) {
                      next();
                    },
                  },
                  {
                    name: 'jwt_reauthorize',
                    path: 'reauthorize',
                    component: () =>
                      import('@/components/data-sources/SFDCJwtFields.vue'),
                    beforeEnter: requireScope('write:data-sources'),
                    props: (route) => ({
                      feedId: route.query.feed_id
                        ? parseInt(route.query.feed_id)
                        : undefined,
                    }),
                  },
                  {
                    name: 'field-preset-new',
                    path: 'preset/new',
                    component: FieldPresetEditor,
                    beforeEnter: (to, from, next) => {
                      if (
                        to.params.tab ===
                        DataSourceSettingsTabType.FIELD_PRESETS
                      ) {
                        next();
                      } else {
                        next({
                          name: 'data-sources-settings-new',
                          params: to.params,
                        });
                      }
                    },
                    props: (route) => ({
                      feedId: parseInt(route.params.id),
                      sourceId: route.params.source_id
                        ? parseInt(route.params.source_id)
                        : undefined,
                      isCreatingNewPreset: true,
                    }),
                  },
                  {
                    name: 'field-preset-edit',
                    path: 'preset/:presetId/edit',
                    component: FieldPresetEditor,
                    beforeEnter: (to, from, next) => {
                      if (
                        to.params.tab ===
                        DataSourceSettingsTabType.FIELD_PRESETS
                      ) {
                        next();
                      } else {
                        next({
                          name: 'data-sources-settings-new',
                          params: to.params,
                        });
                      }
                    },
                    props: (route) => ({
                      feedId: parseInt(route.params.id),
                      sourceId: route.params.source_id
                        ? parseInt(route.params.source_id)
                        : undefined,
                      presetId: parseInt(route.params.presetId),
                    }),
                  },
                ],
              },
              dataTemplatesRoute({
                name: 'data-templates',
                path: 'feed/:id/setup',
                closeRoute: 'data-sources',
              }),
              {
                name: 'delete-source',
                path: 'source/:source_id/delete',
                beforeEnter: requireScope('write:data-sources'),
                component: RemoveSourceModal,
                props: (route) => ({
                  sourceId: parseInt(route.params.source_id),
                }),
              },
              {
                name: 'data-sources-rename',
                path: 'feed/:id/rename',
                component: DataSourceRenameModal,
                beforeEnter: requireScope('write:data-sources'),
                props: (route) => ({
                  feedId: parseInt(route.params.id),
                  nickname: route.query.nickname,
                }),
              },
              {
                name: 'file-uploads',
                path: 'file-uploads',
                component: FileUploads,
              },
              {
                name: 'file-upload-add-data',
                path: 'file-uploads/add-data/:id',
                component: FileUploads,
                props: (route) => ({ sourceId: parseInt(route.params.id) }),
              },
              {
                name: 'map-ae-columns',
                path: 'file-uploads/map-columns/:id',
                component: MapAEColumns,
                props: (route) => ({ sourceId: parseInt(route.params.id) }),
              },
              {
                name: 'map-fields-columns',
                path: 'map-fields-columns/:id',
                component: MapFieldsColumns,
                props: (route) => ({
                  accountSourceId: parseInt(route.params.id),
                }),
                beforeEnter(_to, _from, next) {
                  next();
                },
              },
              {
                name: 'google-sheets',
                path: 'google-sheets',
                component: GoogleSheets,
              },
              {
                name: 'dynamics-pick-crm',
                path: 'dynamics-pick-crm',
                component: DynamicsPickCrm,
                props: (route) => ({
                  instances: JSON.parse(route.query.instances),
                }),
                beforeEnter(to, _, next) {
                  const instances = to.query.instances
                    ? JSON.parse(to.query.instances)
                    : null;
                  if (!instances || !instances.length === 0) {
                    /* Either the user refreshes the page before picking a source,
                        or they don't have any CRMs in their MD account */
                    flashesStore.addErrorFlash({
                      message:
                        'There was an issue connecting to your Microsoft Dynamics account',
                    });
                    next({ name: 'data-sources' });
                  } else {
                    next();
                  }
                },
              },
            ],
          },
          {
            name: 'overlaps',
            path: '/overlaps',
            component: Overlaps,
          },

          // -----------------
          //    Co-Sell
          // -----------------
          {
            name: 'co_sell',
            path: '/co-sell/:pathMatch(.*)*',
            component: CoSell,
          },

          // -----------------
          //    user
          // -----------------

          {
            name: 'user_settings',
            path: '/profile/preferences',
            component: UserSettings,
            children: [
              {
                component: UserInfo,
                path: '/profile/preferences/edit',
                name: 'user_info_modal',
              },
            ],
          },

          // -----------------
          // integrations oauth callback
          // -----------------

          {
            name: 'oauth-callback',
            path: '/oauth/callback',
            component: OAuthCallback,
          },
          {
            name: 'slack_callback',
            path: '/slack/callback',
            component: SlackCallback,
          },
          {
            name: 'partnerstack_callback',
            path: '/partnerstack/callback',
            component: PartnerstackCallback,
          },
          {
            name: 'bitts-playground',
            path: '/bitts-playground',
            component: import.meta.env.DEV ? BittsPlayground : NotFound,
          },
          {
            path: '/:pathMatch(.*)*',
            name: 'not_found',
            component: NotFound,
          },
        ],
      },
      {
        beforeEnter: (to, from, next) =>
          enforceAuthentication(to, from, next, false),
        name: 'upgrade-locked',
        path: '/upgrade',
        component: ConnectorUpgrade,
      },
    ],
    async scrollBehavior(to, from, savedPosition = null) {
      /* Suspense components don't register in time if we use vanilla vue router
        "el" in the returned object. We need to wait for the element to appear */
      const getElementByHash = (hash, tries = 0) => {
        return (
          document.querySelector(hash) ||
          new Promise((resolve, reject) => {
            if (tries === 5)
              reject(new Error(`element with ${hash} could not be found`));
            setTimeout(() => {
              resolve(getElementByHash(hash, (tries += 1)));
            }, 100);
          })
        );
      };
      if (to.hash) {
        try {
          const el = await getElementByHash(to.hash);
          const position = {
            el,
            top: 80, // offset to accommodate universal search area
            behavior: 'smooth',
          };
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve(position);
            }, 200);
          });
        } catch (err) {
          console.warn(err);
        }
      }

      // The third argument, savedPosition, is only available if
      // this is a popstate navigation(triggered by the browser's back/forward buttons).
      // Logic here is to go back to correct vertical spot when not using back/forward.
      // The "scroll" query param should be passed to keep track of window.scrollY
      const position = { left: 0, top: 0 };
      const { scroll } = to.query;
      const hasSameBaseRoute = to.matched[1] === from.matched[1];
      if (hasSameBaseRoute && Boolean(scroll)) position.top = window.scrollY;
      // don't hop to top when sorting
      if (to.path === from.path) return false;
      // don't scroll when navigating to/from modal routes
      if (hasSameBaseRoute && (to.meta?.modal || from.meta?.modal))
        return false;
      return savedPosition || position;
    },
  };

  const router = _createRouter(routerConfig);

  router.beforeEach((to, _from, next) => {
    if (store.maintenanceModeEvent && to.name !== 'maintenance_mode') {
      next({ name: 'maintenance_mode' });
    } else if (to.meta.featureFlag && !hasFeatureFlag(to.meta.featureFlag)) {
      next({ name: 'home' });
    } else {
      next();
    }
  });
  router.beforeEach((to, from, next) => {
    const onboardingRoute = '/onboarding';
    const comingSoonRoute = '/coming-soon';

    if (to.path === comingSoonRoute || to.path === onboardingRoute) {
      return next();
    }

    const isInitialLanding = !from.name;
    const needsOnboarding = store.currentOrg?.setup_menu_hidden === false;

    if (
      isInitialLanding &&
      needsOnboarding &&
      to.path === '/partners' &&
      !store.hasIntegrationUserRole
    ) {
      return next(onboardingRoute);
    }

    next();
  });

  const INTEGRATION_USER_BLOCKED_PATHS = [
    '/account-mapping',
    '/generate-pipeline',
    '/deal-navigator',
    '/lists',
    '/attribution',
    '/labs',
    '/invitations/partner-wishlist',
    '/organization/settings',
    '/organization/api-keys',
    '/co-sell/settings',
    '/team',
    '/roles',
    '/billing',
    '/self-serve',
    '/profile/preferences',
    '/partners',
    '/sharing-settings/population',
  ];

  router.beforeEach((to, _from, next) => {
    if (!store.hasIntegrationUserRole) return next();

    if (
      INTEGRATION_USER_BLOCKED_PATHS.some((path) => to.path.startsWith(path))
    ) {
      return next({ path: '/data-sources' });
    }

    next();
  });

  router.onError((error) => {
    if (
      error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Importing a module script failed')
    ) {
      window.location.reload();
    }
  });

  // Want to track page views in our analytics tooling
  router.afterEach((to, from) => {
    if (to.path === from.path) return;

    if (window.analytics) {
      if (store.state?.currentOrg?.id) {
        window.analytics.page({
          organization_id: store.currentOrg.id.toString(),
        });
      } else {
        window.analytics.page();
      }
    }
  });

  // Handle NavigationDuplicated errors
  // https://github.com/vuejs/vue-router/issues/2881
  const originalPush = router.push;
  router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch((err) => {
      if (isNavigationFailure(err)) {
        // resolve err
        console.warn(err);
        return err;
      }
      // rethrow error
      return Promise.reject(err);
    });
  };

  const originalReplace = router.replace;
  router.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalReplace.call(this, location, onResolve, onReject);
    }
    return originalReplace.call(this, location).catch((err) => {
      if (isNavigationFailure(err)) {
        // resolve err
        console.warn(err);
        return err;
      }
      // rethrow error
      return Promise.reject(err);
    });
  };

  return router;
};

const fullWidthAuthenticatedRoutes = ['/self-serve'];
